import { render, staticRenderFns } from "./MagicLinkExpirationPopup.vue?vue&type=template&id=17118c34&scoped=true"
import script from "./MagicLinkExpirationPopup.vue?vue&type=script&lang=js"
export * from "./MagicLinkExpirationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17118c34",
  null
  
)

export default component.exports